

import React, { useState, useEffect, useMemo } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation, useNavigate } from "react-router-dom";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { useAuth } from './AuthContext';

const stripePromise = loadStripe("pk_live_51QjDQYJghU42dndgruuEdC41dBTsyZmQM2RVdgWU92ttInlq7UDmdtCSSCmpq5gab1QB7Ac0Xo3UN3w6Pc87CQQ7000rjlkps9");

const BACKEND_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const CheckoutForm = () => {
    const [clientSecret, setClientSecret] = useState(null);
    const { state } = useLocation();
    const navigate = useNavigate();  

    const { user, token } = useAuth();
    const [error, setError] = useState(null);

    useEffect(() => {
        setError(null);

        if (state?.selectedItems) {
            const formattedItems = state.selectedItems.map(item => ({
                price_id: item.id,
                quantity: item.quantity || 1  
            }));

            const fetchClientSecret = async () => {
                try {
                    const headers = { "Content-Type": "application/json" };
                    if (token) {
                        headers["Authorization"] = `Bearer ${token}`;
                    }

                    const response = await fetch(
                        `${BACKEND_URL}/checkout/create-session`,
                        {
                            method: "POST",
                            mode: "cors",
                            headers,
                            body: JSON.stringify({ items: formattedItems }) 
                        }
                    );

                    if (!response.ok) {
                        const errData = await response.json();
                        throw new Error(errData.error || "Failed to fetch client secret");
                    }

                    const data = await response.json();
                    console.log(data)
                    if (data.clientSecret) {
                        setClientSecret(data.clientSecret);
                    } else {
                        throw new Error("Invalid clientSecret received from server");
                    }
                } catch (error) {
                    console.error("Error fetching client secret:", error);
                    setError(error.message || "Failed to initialize payment gateway. Please try again.");
                }
            };

            fetchClientSecret();
        } else {
            setError("No items selected for purchase. Please go to the pricing page.");
        }
    }, [state, token]);


    if (error) {
        return (
            <div className="checkout-page" style={{ textAlign: "center", padding: "40px" }}>
                <div className="auth-alert error" style={{ display: "inline-block", maxWidth: "500px" }}>
                    <strong>Checkout Error:</strong> {error}
                </div>
                <div style={{ marginTop: "20px" }}>
                    <button className="body-button" onClick={() => navigate("/pricing")}>Go to Pricing</button>
                </div>
            </div>
        );
    }

    if (!stripePromise || !clientSecret) {
        return (
            <div className="checkout-page" style={{ textAlign: "center", padding: "60px" }}>
                <p style={{ fontSize: "18px", color: "#214DA0" }}>Loading checkout gateway safely...</p>
            </div>
        );
    }
  const handleSuccess = () => {
        // Handle successful checkout, e.g., navigate to a success page
        navigate("/success");  // Redirect to a success page, or display success message
    };

    const handleError = (error) => {
        console.error("Checkout failed:", error);
        // You can also display an error message to the user
    };
    return (
        <div className="checkout-page">
        <div id="checkout" >
            <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
                <EmbeddedCheckout 
                onPaymentSuccess={handleSuccess}  
                onPaymentError={handleError} /> 
            </EmbeddedCheckoutProvider>
        </div>
        </div>
    );
};

export default CheckoutForm;
